import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["FooterClient"] */ "/vercel/path0/src/components/ui/FooterClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderClient"] */ "/vercel/path0/src/components/ui/HeaderClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/WhatsappCTAButton.tsx");
